export default "__VITE_ASSET__QKVFKrY4__"